import * as types from "../types";
import * as _api from "../../api";
import { call, put, takeLatest } from "@redux-saga/core/effects";
import { clearErrors, returnErrors } from "../actions/errorAction";
import { featureSettingsFailure, featureSettingsSuccess } from "../actions/fetchFeatureSettingAction";

function* asynFetchFeatureSettings(action){
    try{
        yield put(clearErrors());
        let resFeature = yield call(_api.fetchFeatureSettingsApi,{
            reqKey: action.payload.reqKey
        });
        yield put(featureSettingsSuccess({resFeature}));
    }catch(e){
        yield put(returnErrors({msg:e.message, status: true}));
        yield put(featureSettingsFailure({error: e}));
    }

}

export default function* fetchFeatureSettingSaga(){
   yield takeLatest(types.FETCH_FEATURE_SETTING_REQUEST, asynFetchFeatureSettings);
}